import React from "react";
import {Form, Select, Input, InputNumber} from 'antd';
import NHFormItem from '../../common/NHFormItem/index';
import NHSelect from "../../common/NHSelect";

const FormItem = Form.Item;

class EditInitForm extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
        }
    }


    render() {       
        const {form, initFormData} = this.props;
        return (
            <div>
                <Form layout="horizontal">
                    <NHFormItem id={'lxfsmc'} label={'联系方式名称'} hasFeedback={true} form={form} required={true}
                                pattern={{max: 100, message: "联系方式名称长度不能超过100字符！"}}
                                initialValue={initFormData ? initFormData.lxfsmc : ''}>
                        <Input placeholder="请输入联系名称"/>
                    </NHFormItem>
                    <NHFormItem id={'lxfshm'} label={'联系号码'} hasFeedback={true} form={form} required={true}
                                pattern={{max: 20, message: "联系号码长度不能超过20字符！"}}
                                initialValue={initFormData ? initFormData.lxfshm : ''}>                              
                        <Input placeholder="请输入联系号码"/>
                    </NHFormItem>
                    <NHFormItem id={'zt'} label={'是否启用'} form={form} required={true}
                        initialValue={initFormData ? initFormData.zt:'1'}>
                        <Select placeholder={'请选择类型'}>
                            <Select.Option key={'0'}>停用</Select.Option>
                            <Select.Option key={'1'}>启用</Select.Option>
                        </Select>
                    </NHFormItem>   
                    <NHFormItem id={'pxh'} label={'排序号'} hasFeedback={true} form={form}
                                initialValue={initFormData ? initFormData.pxh : 1}>
                        <InputNumber/>
                    </NHFormItem>                 
                </Form>
            </div>
        );
    }
}


const EditForm = Form.create()(EditInitForm);

export default EditForm;


// WEBPACK FOOTER //
// ./components/fwwgl/lxfs/EditForm.js